export const topRight = { value: "top-right", text: "Top Right" };
export const topLeft = { value: "top-left", text: "Top Left" };
export const bottomRight = { value: "bottom-right", text: "Bottom Right" };
export const bottomLeft = { value: "bottom-left", text: "Bottom Left" };
